var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var gql = String.raw;
export var allEntityTypes = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  allEntityTypes {\n    ...EntityBaseFields\n    internalName\n  }\n"], ["\n  allEntityTypes {\n    ...EntityBaseFields\n    internalName\n  }\n"])));
var templateObject_1;